import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=270ff158&scoped=true&"
import script from "./EventHistory.vue?vue&type=script&lang=js&"
export * from "./EventHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ff158",
  null
  
)

export default component.exports